<div #assignMenuRoot data-test-id="assign-menu" class="assign-menu">
	<p data-test-id="assign-menu-header"><b>
		Rollen für {{ title }} im Verfahren <span class="aktenzeichen">{{ selectedVerfahrenAktenzeichen }}</span>
	</b></p>
	<div class="grid">
		@for (kontaktKategorie of (kontaktKategorie | enumToArray); track kontaktKategorie) {
			<schir-int-client-one-value-editor [type]="'checkbox'" [formGroup]="form"
			                                   [label]="kontaktKategorie | enumToLabel: kontaktKategorieLabel"
			                                   [fieldControl]="getFormControl(kontaktKategorie)"
			                                   data-test-id="assign-menu-item"/>
		}
	</div>
	<span class="visually-hidden" role="alert">{{ audioAlert | async }}</span>
</div>
